module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": _vm.getDevices
    },
    model: {
      value: (_vm.filters.projectId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "projectId", $$v)
      },
      expression: "filters.projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点位名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "deviceId", $$v)
      },
      expression: "filters.deviceId"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.deviceId,
      attrs: {
        "label": item.name,
        "value": item.deviceId
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.type == 0) ? _c('el-form-item', {
    attrs: {
      "label": "点位编码"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "deviceId", $$v)
      },
      expression: "filters.deviceId"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.deviceId,
      attrs: {
        "label": item.mnCode,
        "value": item.deviceId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间范围"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": "",
      "AddButtonShow": "",
      "ResetButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.maintenanceRecordList,
      "border": "",
      "highlight-current-row": "",
      "size": "mini",
      "height": _vm.formHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "label": "项目名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "siteName",
      "label": "点位名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "送检日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expiration",
      "label": "有效期至"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "送检证书"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.picture == '' || scope.row.picture == null) ? _c('span') : _c('span', [_c('el-image', {
          staticStyle: {
            "width": "30px",
            "height": "16px"
          },
          attrs: {
            "src": "/static/query.png",
            "preview-src-list": scope.row.srcList
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "描述信息"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('table-update-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), (_vm.type == 0) ? _c('table-delete-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [20, 50, 100, 200],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.titleType,
      "visible": _vm.dialogRecordVisible,
      "append-to-body": true,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogRecordVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formUserDevops",
    attrs: {
      "model": _vm.formUserDevops,
      "label-width": "100px",
      "rules": _vm.formRules
    }
  }, [(_vm.titleType == '新增') ? _c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "prop": "projectId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": _vm.getDevicesForm
    },
    model: {
      value: (_vm.formUserDevops.projectId),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "projectId", $$v)
      },
      expression: "formUserDevops.projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 1 && _vm.titleType == '新增') ? _c('el-form-item', {
    attrs: {
      "label": "点位名称",
      "prop": "deviceId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formUserDevops.deviceid),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "deviceid", $$v)
      },
      expression: "formUserDevops.deviceid"
    }
  }, _vm._l((_vm.devicesFrom), function(item) {
    return _c('el-option', {
      key: item.DeviceId,
      attrs: {
        "label": item.Name,
        "value": item.DeviceId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 0 && _vm.titleType == '新增') ? _c('el-form-item', {
    attrs: {
      "label": "点位编码",
      "prop": "deviceId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formUserDevops.deviceid),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "deviceid", $$v)
      },
      expression: "formUserDevops.deviceid"
    }
  }, _vm._l((_vm.devicesFrom), function(item) {
    return _c('el-option', {
      key: item.DeviceId,
      attrs: {
        "label": item.MnCode,
        "value": item.DeviceId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校准日期",
      "prop": "time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formUserDevops.time),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "time", $$v)
      },
      expression: "formUserDevops.time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期至",
      "prop": "expiration"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formUserDevops.expiration),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "expiration", $$v)
      },
      expression: "formUserDevops.expiration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "送检证书",
      "prop": "picture"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "#",
      "http-request": _vm.httpRequest,
      "name": "file",
      "on-change": _vm.change,
      "on-remove": _vm.remove,
      "accept": "image/*",
      "file-list": _vm.fileListShow,
      "list-type": "picture",
      "multiple": "",
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传图片文件，且最好不超过500kb")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述信息",
      "prop": "remark"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formUserDevops.remark),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "remark", $$v)
      },
      expression: "formUserDevops.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-48c066e4"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/DeviceInspectionRecord.vue
// module id = 1912
// module chunks = 1